import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, Typography } from '@material-ui/core';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  spinnerDefault: {
    animationDuration: '600ms',
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  spinnerSuccess: {
    animationDuration: '600ms',
    marginBottom: theme.spacing(1),
    color: theme.palette.success.main,
  },
  overlay: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: 999,
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    color: theme.palette.primary.contrastText,
  },
}));

const LoadingOverlay = ({ indicatorSize, message, variant }) => {
  const classes = useStyles();
  const progressClassName = variant === 'success' ? classes.spinnerSuccess : classes.spinnerDefault;

  return (
    <div className={classes.overlay}>
      <div className={classes.container}>
        <CircularProgress
          className={progressClassName}
          disableShrink
          size={indicatorSize}
          thickness={5}
          data-testid="uia-circular-progress"
        />
        <Typography variant="body2" component="div" className={classes.message}>
          {message}
        </Typography>
      </div>
    </div>
  );
};

LoadingOverlay.propTypes = {
  indicatorSize: PropTypes.number,
  message: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'success']),
};

LoadingOverlay.defaultProps = {
  indicatorSize: 24,
  message: null,
  variant: 'default',
};

export default LoadingOverlay;
